import { render, staticRenderFns } from "./brokerage.vue?vue&type=template&id=2a721933&scoped=true"
import script from "./brokerage.vue?vue&type=script&lang=js"
export * from "./brokerage.vue?vue&type=script&lang=js"
import style0 from "./brokerage.vue?vue&type=style&index=0&id=2a721933&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a721933",
  null
  
)

export default component.exports